import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './app';
import SpinnerOverlay from './components/common/spinner/spinner';
import Warn from './components/common/warn';
import ErrorPage from './components/error-page';
import './index.scss';
import Apollo from './services/apollo/apollo';
import Auth from './services/auth/auth';
import { EnvContext } from './services/env';
import SessionTimeout from './services/timeout/session-timeout';
import { IEnvConfig } from './types/auth';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<SpinnerOverlay />);

function configureAndLoadAppInsights(config: IEnvConfig) {
  // if app insights isn't set up, skip trying to load it
  if (!config || !config.applicationInsightsConnectionString) return;
  
  const browserHistory = createBrowserHistory();
  const reactPlugin = new ReactPlugin();
  const appInsights = new ApplicationInsights({
    config: {
        connectionString: config.applicationInsightsConnectionString,
        enableAutoRouteTracking: true,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory }
        }
    }
  });
  
  appInsights.loadAppInsights();
}

fetch('public/env-config')
  .then(response => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(response.statusText);
    }
  })
  .then((config: IEnvConfig) => {
    configureAndLoadAppInsights(config);
    root.render(
      <React.StrictMode>
        <EnvContext.Provider value={config}>
          <Auth>
            <Apollo>
              <App />
              <ToastContainer />
              <Warn />
              <SessionTimeout />
            </Apollo>
          </Auth>
        </EnvContext.Provider>
      </React.StrictMode>
    )
  })
  .catch(error => {
    root.render(
      <ErrorPage>Service Unavailable</ErrorPage>
    );
  });
